import { render, staticRenderFns } from "./product_details_form.vue?vue&type=template&id=39a30147&scoped=true&"
import script from "../assets/js/product_details_form.js?vue&type=script&lang=js&"
export * from "../assets/js/product_details_form.js?vue&type=script&lang=js&"
import style0 from "./product_details_form.vue?vue&type=style&index=0&id=39a30147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a30147",
  null
  
)

export default component.exports